import type { Site } from '@/types';

export function deviceSiteReady(currentSite: string | null | undefined, sites: Site[] | undefined, pending: boolean, failed: boolean): boolean {
  return !pending && !failed && !!sites && (!currentSite || sites.some((site) => site.code === currentSite));
}

export function devicePatchPayload(label: string, kind: string, currentSite: string | null | undefined, selectedSite: string, siteChanged: boolean) {
  return {
    label,
    kind,
    ...(siteChanged && selectedSite && selectedSite !== currentSite ? { site_code: selectedSite } : {}),
  };
}
